import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseFormComponent } from '@classes/extends';
import { RFSurface, SurfacesMillesime } from '@estel-numerique/galaclick-api';
import { TraductionCoreService, ValidatorPatternService } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { DialogGalaComponent } from '../../../../composants/dialog-gala/dialog-gala.component';
import { SelectGala } from '../../../../composants/select/select.component';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: 'ficheclient-rfsurface.component.html',
    imports: [DialogGalaComponent, FormsModule, ReactiveFormsModule, SelectGala, MatButton]
})
export class FicheClientRfSurfaceComponent extends BaseFormComponent implements OnInit {
    public traductionCore = inject(TraductionCoreService);
    public validPattern = inject(ValidatorPatternService);
    private formBuilder = inject(FormBuilder);
    private dialogRef = inject<MatDialogRef<FicheClientRfSurfaceComponent>>(MatDialogRef);
    public data = inject<RFSurface[]>(MAT_DIALOG_DATA);

    public codeModule: string = Constantes.CodeOption.CFICHECLIENT; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)
    public titre: string;
    // Traductions
    protected lgTrad: Record<string, string> = {};
    public surfaces: SurfacesMillesime = {};
    public rfSurfacesListe: RFSurface[] = [];
    public listeRfSurfaces: RFSurface[];
    public rfSurfacesMillesime: RFSurface[];
    public idClient: number;
    public formAjout = this.formBuilder.group({
        RFSURFACE: [{} as RFSurface, [Validators.required]]
    });;

    @Output() ajouter = new EventEmitter<RFSurface>();

    constructor() {
        super();
        this.lgTrad = {
            AFFSRFC: this.translate.instant('APPFICHECLIENT.AFFSRFC'),
            SURFACES: this.translate.instant('APPFICHECLIENT.SURFACES'),
            ENR: this.translate.instant('ENR'),
            RET: this.translate.instant('RET'),
        };
    }

    ngOnInit() {
        super.ngOnInit();
    }

    public addSurface() {
        this.validationFormulaire(this.formAjout);
        if (this.formAjout.valid) {
            const rfSurface: RFSurface = this.formAjout.value.RFSURFACE;
            this.ajouter.emit(rfSurface);
            this.hideRfModal();
        }
    }

    hideRfModal() {
        this.formAjout.reset();
        this.formAjout.markAsPristine();
        this.formAjout.markAsUntouched();
        this.dialogRef.close();
    }

}
